module.exports = __webpack_public_path__ + "static/agency_4-6bea6aee4362aa88861a233dfd2e5559.svg";